import { render, staticRenderFns } from "./TopUpSuccess.vue?vue&type=template&id=330a6bbb&scoped=true&"
import script from "./TopUpSuccess.vue?vue&type=script&lang=js&"
export * from "./TopUpSuccess.vue?vue&type=script&lang=js&"
import style0 from "./TopUpSuccess.vue?vue&type=style&index=0&id=330a6bbb&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "330a6bbb",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VBtn,VImg})


/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('330a6bbb')) {
      api.createRecord('330a6bbb', component.options)
    } else {
      api.reload('330a6bbb', component.options)
    }
    module.hot.accept("./TopUpSuccess.vue?vue&type=template&id=330a6bbb&scoped=true&", function () {
      api.rerender('330a6bbb', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/ShopInfo/components/TopUpPackage/components/TopUpSuccess.vue"
export default component.exports